import axios from 'axios';

import { MEMBRESIAS } from '../actions/types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const buscarMembresias = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/membresias/listar`, config);

        await dispatch({
            type: MEMBRESIAS.BUSCAR,
            payload: res.data.contrataciones_membresias
        });
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}
